var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"warn pointer",on:{"click":_vm.fnEdit}},[_c('b',[_vm._v(_vm._s(_vm.node.name)+":")]),_c('p',{staticClass:"message"},[_vm._v(_vm._s(_vm.node.errors[0]))])])
}
var staticRenderFns = []

export { render, staticRenderFns }